import { useEffect, useRef } from 'react';

import { useDocumentOcrStore, useMyMoneyFormStore } from '@/modules/UseMyMoney/stores';

interface Props {
  hasAvailableAccounts?: boolean;
}

const useClearInvalidServiceDate = ({ hasAvailableAccounts }: Props) => {
  const { values, handleSetFormValues } = useMyMoneyFormStore();
  const { ocrDocument } = useDocumentOcrStore();

  const prevServiceIdRef = useRef<typeof values.serviceId>(values?.serviceId);
  const prevCustomServiceIddRef = useRef<typeof values.customServiceId>(values?.customServiceId);

  // save previous service for future restoration
  useEffect(() => {
    if (values?.serviceId) {
      prevServiceIdRef.current = values?.serviceId;
    }
    if (values?.customServiceId) {
      prevCustomServiceIddRef.current = values?.customServiceId;
    }
  }, [values?.serviceId, values?.customServiceId]);

  // clear service when date is invalid
  useEffect(() => {
    if (!hasAvailableAccounts) {
      handleSetFormValues({ serviceId: '', customServiceId: '' });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAvailableAccounts]);

  // restore service when date is valid
  useEffect(() => {
    const isServiceExist = ocrDocument?.serviceOptions?.find((service) => service?.serviceId === prevServiceIdRef?.current);

    if (!hasAvailableAccounts || !isServiceExist) {
      return;
    } 

    if (prevServiceIdRef?.current && !values?.serviceId) {
      handleSetFormValues({ serviceId: prevServiceIdRef?.current });
    }

    if (prevCustomServiceIddRef?.current && !values?.customServiceId) {
      handleSetFormValues({ customServiceId: prevCustomServiceIddRef?.current });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAvailableAccounts]);
};

export default useClearInvalidServiceDate;
